<template>
    <convenio-detalhar
        :dataServicos="obterDataServicos()"
        rotaListagem="Gescon_Convenios_Gestor"
        :temAcessoAcoesPlanoTrabalho="$temAcessoView('GESCON-GEST-CONV-PLANO-00')"
        :temAcessoEventos="$temAcessoView('GESCON-GEST-CONV-EVENTO-00')"
        :permiteInserirAtualizarEventos="$temAcessoView('GESCON-GEST-CONV-EVENTO-01')"
        :temAcessoDocumentosEvento="$temAcessoView('GESCON-GEST-CONV-EVENTO-03')"
        :temAcessoMetas="$temAcessoView('GESCON-GEST-CONV-META-00')"
        :temAcessoPrestacaoFinal="$temAcessoView('GESCON-GEST-CONV-06')"
        :permiteAcessarDocumentos="$temAcessoView('GESCON-GEST-CONV-09')"
        :temAcessoPrestacaoMensal="$temAcessoView('GESCON-GEST-CONV-PLANO-02')"


        :temAcessoConsultoria="$temAcessoView('GESCON-GEST-CONV-CONSUL-00')"
        :permiteInserirAtualizarConsultorias="$temAcessoView('GESCON-GEST-CONV-CONSUL-01')"
        :permiteInserirAtualizarMetasConsultorias="$temAcessoView('GESCON-GEST-CONV-METACONSUL-00')"
        :permiteAcessarDocumentosMetasConsultorias="$temAcessoView('GESCON-GEST-CONV-METACONSUL-03')"

        :temAcessoEntrega="$temAcessoView('GESCON-GEST-CONV-ENT-00')"
        
        :permiteCadastrarPrestacaoMensal="$temAcessoView('GESCON-GEST-CONV-03')"
        :permiteExcluirJustificarPrestacaoMensal="$temAcessoView('GESCON-GEST-CONV-04')"
        :permiteEnviarPrestacaoParaAnalise="$temAcessoView('GESCON-GEST-CONV-12')"
        :permiteCadastrarPrestacaoFinal="$temAcessoView('GESCON-GEST-CONV-07')"
        :permiteExcluirPrestacaoFinal="$temAcessoView('GESCON-GEST-CONV-08')"
        :permiteAtualizarPrestacaoFinal="$temAcessoView('GESCON-GEST-CONV-08')"
        :permiteCadastrarDocumentos="$temAcessoView('GESCON-GEST-CONV-10')"
        :permiteExcluirDocumentos="$temAcessoView('GESCON-GEST-CONV-11')"
        :permiteCancelarEventos="$temAcessoView('GESCON-GEST-CONV-EVENTO-02')"
        :permiteInserirMetas="$temAcessoView('GESCON-GEST-CONV-META-01')"
        :permiteCancelarMetas="$temAcessoView('GESCON-GEST-CONV-META-02')"
        :permiteInserirAtualizarAcoesPlanoTrabalho="$temAcessoView('GESCON-GEST-CONV-PLANO-01')"
        :permiteCancelarAcoesPlanoTrabalho="$temAcessoView('GESCON-GEST-CONV-PLANO-02')"
        :permiteInserirCancelarDocumentosEvento="$temAcessoView('GESCON-GEST-CONV-EVENTO-04')"

    ></convenio-detalhar>
</template>

<script>
import ConvenioDetalhar from '../componentes/detalhes/ConvenioDetalhes'
import ConveniosServicos from './ConvenioServicos'

export default {
    components: {
        ConvenioDetalhar
    },

    methods: {
        obterDataServicos() {
            return ConveniosServicos
        }
    }
}
</script>